var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44086_11790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98648 7.72142V5.31461H8.25164V7.72142H7.98648ZM8.1698 10.0671C8.15371 10.0738 8.13647 10.0772 8.11906 10.0772C8.0839 10.0772 8.05018 10.0633 8.02531 10.0384C8.00045 10.0135 7.98648 9.97982 7.98648 9.94466C7.98648 9.9095 8.00045 9.87578 8.02531 9.85091C8.05018 9.82605 8.0839 9.81208 8.11906 9.81208C8.13647 9.81208 8.15371 9.81551 8.1698 9.82218L8.36493 9.35107L8.1698 9.82218C8.18588 9.82884 8.2005 9.8386 8.21281 9.85091L8.56094 9.50278L8.21281 9.85091C8.22512 9.86323 8.23489 9.87784 8.24155 9.89392C8.24821 9.91001 8.25164 9.92725 8.25164 9.94466C8.25164 9.96207 8.24821 9.97931 8.24155 9.9954C8.23488 10.0115 8.22512 10.0261 8.21281 10.0384L8.57337 10.399L8.21281 10.0384C8.2005 10.0507 8.18588 10.0605 8.1698 10.0671Z",
    fill: "#FD3757",
    stroke: "#FD3757",
    strokeWidth: 1.01984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12076 14.0228C11.6133 14.0228 14.4446 11.1915 14.4446 7.69889C14.4446 4.2063 11.6133 1.375 8.12076 1.375C4.62818 1.375 1.79688 4.2063 1.79688 7.69889C1.79688 11.1915 4.62818 14.0228 8.12076 14.0228Z",
    stroke: "#FD3757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8508 15.985C16.0504 16.1758 16.3669 16.1687 16.5577 15.9691C16.7486 15.7695 16.7414 15.453 16.5418 15.2621L15.8508 15.985ZM16.5418 15.2621L12.9315 11.8105L12.2404 12.5333L15.8508 15.985L16.5418 15.2621Z",
    fill: "#FD3757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44086_11790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(0.75 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconNew);
export default __webpack_public_path__ + "static/media/errorIconNew.64531683935898bcd7f6bb4e99c436be.svg";
export { ForwardRef as ReactComponent };